import React, { Component } from "react";
import { Modal } from "antd";

class ModalConfirmation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
        };
    }

    render() {
        const { confirmLoading } = this.state;
        const { toggleShowModal, showModal, handleAction, title, caption, buttonText, buttonTextCancel } = this.props;
        return (
            <Modal
                title={title}
                visible={showModal}
                confirmLoading={confirmLoading}
                okText={buttonText ? buttonText : "Submit"}
                cancelText={buttonTextCancel ? buttonTextCancel : "Cancel"}
                onOk={() => handleAction()}
                onCancel={() => toggleShowModal(false)}
                width={450}>
                    <div>{caption}</div>
            </Modal>
        );
    }
}

export default ModalConfirmation;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Modal/ModalConfirmation.js